import React from 'react';
import { RoutePermittedRole } from 'shared/constants/AppConst';
const List = React.lazy(() => import('./ComplianceLisiting/index.js'))
const Create= React.lazy(() => import('./Add Compliance/index'))
const ComplianceSettings = React.lazy(() => import('./Setting'))

export const ComplianceConfig = [
  {
    permittedRole: [RoutePermittedRole.superAdmin],
    path: '/master/compliance/list',
    element: <List />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/compliance/settings',
    element: <ComplianceSettings />,
  },
  {
    permittedRole: [RoutePermittedRole.superAdmin],
    path: '/master/compliance/create',
    element: <Create />,
  },
];